<template>
  <div
    :data-qa="dataQa"
    :class="$props.class"
    :style="style"
  >
    <base-label
      :class="$style.label"
      :for="id"
    >
      <span v-if="label">{{ label }}</span>
    </base-label>
    <base-textarea
      v-bind="$attrs"
      :id="id"
    />
  </div>
</template>

<script>
import BaseLabel from '@/shared/legacy/ui/label/label.vue';
import BaseTextarea from '@/shared/legacy/ui/textarea/textarea.vue';

export default {
  name: 'TextareaFormField',
  components: {
    BaseLabel,
    BaseTextarea
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default: undefined
    },
    label: {
      type: String,
      default: undefined
    },
    dataQa: {
      type: String,
      default: undefined
    },
    class: {
      type: [String, Array, Object],
      default: undefined
    },
    style: {
      type: [String, Array, Object],
      default: undefined
    }
  }
};
</script>

<style lang="less" module>
.label {
  display: inline-block;
  margin-bottom: 4px;
}
</style>

<i18n lang="json">{}</i18n>
